import Vue from 'vue';
// 导入自己需要的组件
import { Transfer,Table,TableColumn,Tree,Input,Form,FormItem,ColorPicker,Select,Option,Message,DatePicker,Link,} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Transfer);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tree);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(ColorPicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Link);
Vue.prototype.$message = Message;
const  customElement = {
	Transfer:Transfer,
    Table:Table,
    TableColumn:TableColumn,
    Tree:Tree,
    Input:Input,
    Form:Form,
    FormItem:FormItem,
    ColorPicker:ColorPicker,
    Select:Select,
    Option:Option,
    DatePicker:DatePicker,
    Link:Link,
};
export default customElement


